/**
 * SET販売明細の set_ids / set_items に入っている構成商品IDから
 * Inventory マスターのJANを取得。取得できないJANを黙って落とさない。
 * 戻り値は元の各明細に setJans を追加した新しい配列。
 */

export const getSetComponentIds = (item) => {
  const raw = item.set_ids ?? item.set_items ?? item.setItems ?? "";
  const values = Array.isArray(raw) ? raw : String(raw).split(",");
  return values.map(value => String(value ?? "").trim()).filter(Boolean);
};

export const isSetSale = (item) =>
  Number(item.set_sale ?? 0) > 0 || getSetComponentIds(item).length > 0;

export const resolveSetJansForItems = async (items, fetchInventory) => {
  if (typeof fetchInventory !== "function") {
    throw new Error("構成商品のJAN取得処理が指定されていません");
  }

  const cache = new Map();
  const fetchJan = (id) => {
    if (!/^\d+$/.test(id) || Number(id) <= 0) {
      throw new Error(`SET構成商品IDが不正です: ${id}`);
    }
    if (!cache.has(id)) {
      cache.set(id, Promise.resolve().then(async () => {
        const inventory = await fetchInventory(id);
        const jan = String(inventory?.jan ?? "").trim().replace(/[\sー－-]/g, "");
        if (!/^\d{8,18}$/.test(jan)) {
          throw new Error(`SET構成商品ID ${id} のJANを取得できません（マスターのJANを確認してください）`);
        }
        return jan;
      }));
    }
    return cache.get(id);
  };

  return Promise.all(items.map(async item => {
    const ids = isSetSale(item) ? getSetComponentIds(item) : [];
    if (!ids.length) return { ...item, setJans: [] };
    const setJans = await Promise.all(ids.map(fetchJan));
    return { ...item, setJans };
  }));
};
